module.exports = __webpack_public_path__ + "img/ch-demographics.350398de.jpg";